import { div } from '@mui/system'
import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilled, ButtonFilledAutoWidth } from '../../../components/button'
import { TextAreaInput1, TextInput } from '../../../components/input'
import { CreateDepartmentService, UpdateDepartmentService } from '../../../services/DepartmentServices'
import { useNavigate, useLocation } from 'react-router-dom'
import { MobileBackOption } from '../../../components/appbars/mobile/DashboardMobile'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { message } from 'antd'
import { CreateFollowupService, UpdateFollowupService } from '../../../services/admin/FollowupServices'
import { CreateFileStandardService, UpdateFileStandardService } from '../../../services/admin/FileStandardServices'

function FileStandardCE() {
 
  const [data,setdata] = useState({standard:'',label:'',match_string:''});  
  const [error,seterror] = useState({standard:'',label:'',match_string:''}); 
  
  const {state} = useLocation();
  const navigate = useNavigate();


  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      setdata({...data,...state})
    }

  },[state])

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    if(!data.standard){
        seterror({...error,standard:'Standard field is required *'})
    }else if(!data.label){
        seterror({...error,label:'Label field is required *'})
    }else if(!data.match_string){
        seterror({...error,match_string:'Match String field is required *'})
    }else{
        if(state?._id === undefined || state?._id === null){
        const response = await CreateFileStandardService(data)
        if (response.status === 201) {
          resetform()
          toast.success('File Standard Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,days:response?.data?.errors?.days})
        } 
      }else{
        let send_data = {...data}
        const response = await UpdateFileStandardService(send_data,state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('File Standard Updated Successfully')
        }   
        if(response.status === 422){
           seterror({...error,days:response?.data?.errors?.days})
        } 
      }
  }
  }


  function resetform(){
    setdata({standard:'',label:'',match_string:''})
    seterror({standard:'',label:'',match_string:''})
  }
  

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
    <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack /> 

        <h6 className='font-[700]'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'} Filter Standard</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Filter Standard</b> for your clients segregate followup.</h6>
     

        <TextInput 
            label={'Standard'}  
            variant="standard"
            name="standard"
            type="number"
            error={error.standard}
            value={data.standard}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

          <TextInput 
            label={'Label (Class Name)'}  
            variant="standard"
            name="label"
            type="text"
            error={error.label}
            value={data.label}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>  

             <TextAreaInput1 
            label={'Match String'}  
            variant="standard"
            name="match_string"
            type="text"
            error={error.match_string}
            value={data.match_string}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

        <div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE FILE STANDARD" : "ADD FILE STANDARD"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default FileStandardCE